export default __webpack_public_path__ + "static/media/arrow_right.b8d7d4b4.svg";